import { lazy } from 'react';
import { Suspense } from '@app/components/Suspense';

const Lazy = lazy(() => import('./Page'));

export default function PasswordResetInstructions(props: any): JSX.Element {
  return <Suspense loaderMessage="LoadingPage" component={<Lazy {...props} />} />;
}
